import {PropsWithChildren} from "react";
import {StyleSheet, View} from "react-native";
import {ThemeType} from "@/theming/baseTheme";
import {useCurrentTheme} from "@/theming/useCurrentTheme";

interface Props extends PropsWithChildren {
    color?: string
}

export function CenterContainer({children, color}: Props) {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme, color);
    return (
        <View style={styles.container}>
            {children}
        </View>
    );
}

const createStyles = (theme: ThemeType, color?: string) => StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: (theme.colors as any)[color || 'background'] || theme.colors.background,
    },
});
